import axios from 'axios';

import config from 'config';

const ROOT_URL = config.url;

class API{
    clear(){
        this.token=null;
        this.loggedIn=false;
    }
    logout(){
        return this.getToken(false, true)
        .then(token => {
            if(!token) return;
            const config = {
                baseURL: ROOT_URL,
                url:'/logout',
                method:'post',
                headers:{
                    'X-Token':token
                }
            }
            return axios(config);
        })
        .catch(()=>{})
        .then(()=>{
            this.clear();
        })
    }
    setToken(token){
        this.token = token;
        this.loggedIn=true;
    }
    validateToken(clientID,userID,token){
        if(!token) return Promise.reject({message:'No token provided'});
        const config = { 
            method:'get',
            url: `${ROOT_URL}/clients/${clientID}/users/${userID}`,
            headers:{} 
        };
        config.headers['X-Token'] = token;
        return axios(config)
        .then(response => {
            this.setToken(token);
            return response.data;
        })
        .catch(error => {
            this.logout();
            throw error;
        })
    }
    login(email,password){
        this.token=null;
        this.loggedIn=false;
        const config = {
            url:'/login',
            method:'post',
            baseURL:ROOT_URL,
            data:{
                email,
                password
            }
        }
        return this.getToken()
        .then(token => {
            if(!config.headers) config.headers={};
            config.headers['X-Token'] = token;
            return axios(config)
        })
        .then(response => {
            this.token = response.data.ID;
            this.loggedIn=true;
            return response.data;
        })
        .catch(error=>{
            let returnError = error;
            if(error.response){
                returnError= typeof error.response.data === 'object' ? error.response.data.error : error.response;
            }
            throw returnError;
        })
    }
    http(config, dontSaveToken){
        config.baseURL = ROOT_URL;
        if(config.data && typeof config.data === 'object'){
            //Remove any underscores
            config.data=Object.keys(config.data)
            .filter(key=>key.substr(0,1) !== '_')
            .reduce((result, current) => {
                result[current] = config.data[current];
                return result;
            }, {});
        }
        return this.getToken(false, dontSaveToken)
        .then(token => {
            if(!config.headers) config.headers={};
            config.headers['X-Token'] = token;
            return axios(config)
        })
        .then(response => {
            return response.data;
        })
        .catch(error => {
            if(error.response && error.response.status === 401){
                this.logout();
                throw error.response;
            }
            let returnError = error;
            if(error.response){
                returnError= typeof error.response.data === 'object' ? error.response.data.error : error.response;
            }
            throw returnError;
        })
    }
    getToken(force, dontSaveToken){
        return new Promise((resolve,reject) => {
            if(this.token && !force){
                return resolve(this.token);
            }
            axios.get(`${ROOT_URL}/tokens/temp`)
            .then(response => {
                if (!dontSaveToken) {
                    this.token = response.data.ID;
                }
                resolve(response.data.ID);
            })
            .catch(reject);
        });
    }
    logError(error,data){
        return;
    }
}

export default new API();


// WEBPACK FOOTER //
// ./src/services/api.js